import { render, staticRenderFns } from "./examresultslist.vue?vue&type=template&id=3aff5dec&scoped=true"
import script from "./examresultslist.vue?vue&type=script&lang=js"
export * from "./examresultslist.vue?vue&type=script&lang=js"
import style0 from "./examresultslist.vue?vue&type=style&index=0&id=3aff5dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aff5dec",
  null
  
)

export default component.exports